import { Children, Fragment, isValidElement } from "react";

export const ContentWithMiddots = ({ children }: React.PropsWithChildren) => {
  const childrenArray = Children.toArray(children).filter((child) => isValidElement(child));

  return (
    <>
      {childrenArray.map((child, index) => (
        <Fragment key={index}>
          {child}
          {index < childrenArray.length - 1 && <span>&middot;</span>}
        </Fragment>
      ))}
    </>
  );
};
